import { useState, useEffect } from "react";
import { projectAuth } from "../firebase/config";
import { useAuthContext } from "./useAuthContext";
import { projectFirestore } from "../firebase/config";
import { includesNumber } from '../utils/includeNumber'

export const useLogin = () => {
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const { dispatch } = useAuthContext();
  const login = async (email, password) => {
    setError(null);
    setIsPending(true);
  
    try {
      // login
      const res = await projectAuth.signInWithEmailAndPassword(email, password);
  
      // dispatch login action
      dispatch({ type: "LOGIN", payload: res.user });
  
      if (includesNumber(res.user.email)) {
        const studentRef = projectFirestore.collection("students").doc(res.user.uid);
        const doc = await studentRef.get();
        
        if (!doc.exists) {
          const userData = {
            email: res.user.email,
            student_id: res.user.email.match(/\d+/)[0],
            form_link: "",
            name: "",
            new_subjects: [],
            status: "Pending"
          };
          // set user data in database
          await studentRef.set(userData);
        }
      } else {
        const supervisorRef = projectFirestore.collection("supervisors").doc(res.user.uid);
        const doc = await supervisorRef.get();
        
        if (!doc.exists()) {
          const userData = {
            email: res.user.email,
            students: [],
            student_ids: [],
            name: "",
          };
          await supervisorRef.set(userData);
        }
      }
  
      if (!isCancelled) {
        setIsPending(false);
        setError(null);
      }
    } catch (err) {
      if (!isCancelled) {
        console.error(err);
        if (err.code === 'auth/user-not-found') {
          setError('خطا: المستخدم غير مسجل بالمنصة');
        } else if (err.code === 'auth/wrong-password') {
          setError('خطا: كلمة المرور او تاريخ الميلاد غير صحيح, قم بارسال بريد الكتروني الى: uob.ee.portal@gmail.com');
        } else {
          setError('حدث خطا, يرجى المحاولة لاحقا');
        }
        
        setIsPending(false);
      }
    }
  };

  return { login, isPending, error };
};
